import React from 'react';
import { NavLink } from 'react-router-dom';

import ButtonBase from '../ButtonBase';

// Exported mainly for tests: React-Router-Dom adds the "active" class on an active NavLink.
export const classes = {
  active: 'active',
};
const ButtonNav = React.forwardRef<HTMLButtonElement, any>(function ButtonNav(props, ref) {
  return <ButtonBase as={NavLink} ref={ref} {...props} />;
});
export default ButtonNav;
